import { Injectable } from '@angular/core';
import {
  CanActivate,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdvanceSalesEnabledGuard implements CanActivate {
  constructor(private auth: AuthService) {}
  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.auth
      .getBusiness()
      .then((el) => {
        return el.enabel_advancedSales;
      })
      .catch(() => {
        return false;
      });
  }
}
